import dayjs from 'dayjs';
import { getHoursAndMinutesFromString } from './getHoursAndMinutesFromString';

export const parseHourStringOnDayjsFormat = (hourString, customDate) => {
  const { hours, minutes } = getHoursAndMinutesFromString(hourString);
  const dateToValidate = customDate || dayjs();

  return dateToValidate.set('hour', hours).set('minute', minutes).second(0);
};
